<template>
  <div class="pb-6" :style="{ width: `${width * 100}%` }" :class="style">
    <!-- LABEL -->
    <div class="text-md font-medium text-default pb-1.5" v-text="label" />
    <!-- ATTRIBUTE VALUE -->
    <div class="mr-2 text-base text-secondary select-all" v-text="utils.isValidStringValue(value) ? value : '-'" />
  </div>
</template>

<script setup lang="ts">
import utils from '@/services/utils'

interface IProps {
  label: string
  value?: string | number
  width?: number
  style?: string[]
}
withDefaults(defineProps<IProps>(), { value: '', width: 1, style: () => [] as string[] })
</script>
